/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ApplicationStage {
  Stage1 = 'APPLICATION_STAGE_1',
  Stage2 = 'APPLICATION_STAGE_2',
  Stage3 = 'APPLICATION_STAGE_3',
  Stage4 = 'APPLICATION_STAGE_4',
  Stage5 = 'APPLICATION_STAGE_5',
  Stage6 = 'APPLICATION_STAGE_6',
  Stage6_5 = 'APPLICATION_STAGE_6_5',
  Stage7 = 'APPLICATION_STAGE_7',
  Stage8 = 'APPLICATION_STAGE_8',
}

export function instanceOfApplicationStage(value: any): boolean {
  for (const key in ApplicationStage) {
    if (Object.prototype.hasOwnProperty.call(ApplicationStage, key)) {
      if (ApplicationStage[key as keyof typeof ApplicationStage] === value) {
        return true
      }
    }
  }
  return false
}

export function ApplicationStageFromJSON(json: any): ApplicationStage {
  return ApplicationStageFromJSONTyped(json, false)
}

export function ApplicationStageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationStage {
  return json as ApplicationStage
}

export function ApplicationStageToJSON(value?: ApplicationStage | null): any {
  return value as any
}
